import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { GoogleLogo } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F9F9F6] grid place-items-center px-6">
      <div className="max-w-md w-full border border-[#D6CFC4] bg-white p-10">
        <div className="overline text-[#B4533C]">Admin · JetsetLess CMS</div>
        <h1 className="font-serif text-4xl mt-3 leading-tight">Sign in to the editorial desk</h1>
        <p className="mt-3 text-sm text-[#4A4742]">Google-authenticated access for editors, authors, and affiliate managers.</p>
        <button
          onClick={login}
          className="mt-8 w-full flex items-center justify-center gap-3 bg-[#1B3B36] text-white px-4 py-3 tracking-wide hover:bg-[#112622] transition-colors"
          data-testid="admin-google-login-btn"
        >
          <GoogleLogo size={20} weight="bold" />
          Continue with Google
        </button>
        <div className="mt-6 text-xs font-mono text-[#4A4742]">First login seeds admin privileges for demo purposes.</div>
      </div>
    </div>
  );
}
